import styled, { css } from "styled-components";

type ButtonProps = {
  danger?: boolean;
  primary?: boolean;
  secondary?: boolean;
  centerContent?: boolean;
  width?: string | null;
};

export const StyledButton = styled.button`
  /* margin-left: 10px; */
  box-shadow: 1px 1px 19px 0px rgba(215, 230, 235, 0.75);
  -webkit-box-shadow: 1px 1px 19px 0px rgba(215, 230, 235, 0.75);
  -moz-box-shadow: 1px 1px 19px 0px rgba(215, 230, 235, 0.75);
  cursor: pointer;
  ${(props: ButtonProps) =>
    props.danger &&
    css`
      background-color: #f84b7a;
    `}

  ${(props: ButtonProps) =>
    props.width &&
    css`
      width: ${props.width};
    `}
`;

export const BasicButton = styled(StyledButton)`
  border: 1px solid #161643;
  padding: 5px 15px;
  font-size: 15px;
  border-radius: 5px;
  font-family: Poppins-SemiBold;
  background-color: #fff;
`;
export const IconButton = styled(StyledButton)`
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 5px;
  border-radius: 5px;
`;

export const RoundedButton = styled(StyledButton)`
  background-color: #fff;
  color: #161643;
  border: 1px solid #161643;
  padding: 12px 25px;
  font-size: 15px;
  border-radius: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${(props: ButtonProps) =>
    props.primary &&
    css`
      background-color: #161643;
      color: #fff;
      font-family: Poppins-Light;
    `}
  ${(props: ButtonProps) =>
    props.centerContent &&
    css`
      justify-content: center;
    `}
`;
